import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const PropertyInfoStep = ({ formData, updateFormData, errors }) => {
  const homeTypeOptions = [
    { value: '', label: 'Selecteer woningtype' },
    { value: 'apartment', label: 'Appartement' },
    { value: 'terraced', label: 'Rijtjeshuis' },
    { value: 'semi-detached', label: 'Twee-onder-een-kap' },
    { value: 'detached', label: 'Vrijstaand huis' },
    { value: 'other', label: 'Anders' }
  ];

  const propertySizeOptions = [
    { value: '', label: 'Selecteer oppervlakte' },
    { value: '< 75m²', label: 'Kleiner dan 75m²' },
    { value: '75-100m²', label: '75-100m²' },
    { value: '100-150m²', label: '100-150m²' },
    { value: '150-200m²', label: '150-200m²' },
    { value: '> 200m²', label: 'Groter dan 200m²' }
  ];

  const energySystemOptions = [
    { value: 'cv-ketel', label: 'CV-ketel (gas)' },
    { value: 'elektrische-verwarming', label: 'Elektrische verwarming' },
    { value: 'warmtepomp', label: 'Warmtepomp' },
    { value: 'zonnepanelen', label: 'Zonnepanelen' },
    { value: 'zonneboiler', label: 'Zonneboiler' },
    { value: 'geen', label: 'Geen duurzame systemen' }
  ];

  const handleEnergySystemToggle = (system) => {
    const current = formData?.currentEnergySystems || [];
    const updated = current?.includes(system)
      ? current?.filter(s => s !== system)
      : [...current, system];
    updateFormData({ currentEnergySystems: updated });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">Woninginformatie</h2>
        <p className="text-muted-foreground">Help ons uw woning beter te begrijpen</p>
      </div>

      {/* Home Type */}
      <Select
        label="Type woning"
        required
        options={homeTypeOptions}
        value={formData?.homeType}
        onChange={(value) => updateFormData({ homeType: value })}
        error={errors?.homeType}
        placeholder="Selecteer uw woningtype"
      />

      {/* Property Size */}
      <Select
        label="Woonoppervlakte"
        options={propertySizeOptions}
        value={formData?.propertySize}
        onChange={(value) => updateFormData({ propertySize: value })}
        placeholder="Selecteer oppervlakte"
      />

      {/* Build Year */}
      <Input
        label="Bouwjaar"
        type="number"
        placeholder="Bijvoorbeeld: 1985"
        value={formData?.buildYear}
        onChange={(e) => updateFormData({ buildYear: e?.target?.value })}
        description="Dit helpt providers de isolatie en energiebehoefte in te schatten"
      />

      {/* Current Energy Systems */}
      <div>
        <label className="text-sm font-medium text-foreground mb-3 block">
          Huidige energiesystemen
        </label>
        <div className="space-y-2">
          {energySystemOptions?.map(system => (
            <div
              key={system?.value}
              onClick={() => handleEnergySystemToggle(system?.value)}
              className="flex items-center p-3 rounded-lg border border-border bg-card hover:bg-accent cursor-pointer transition-colors"
            >
              <Checkbox
                checked={formData?.currentEnergySystems?.includes(system?.value)}
                onCheckedChange={() => handleEnergySystemToggle(system?.value)}
              />
              <span className="ml-3 text-sm text-foreground">{system?.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Location Information */}
      <div className="border-t border-border pt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="MapPin" size={20} className="mr-2 text-primary" />
          Locatie
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Postcode"
            required
            placeholder="1234 AB"
            value={formData?.postalCode}
            onChange={(e) => updateFormData({ postalCode: e?.target?.value?.toUpperCase() })}
            error={errors?.postalCode}
            description="Voor nauwkeurige provider matching"
          />

          <Input
            label="Plaats"
            required
            placeholder="Amsterdam"
            value={formData?.city}
            onChange={(e) => updateFormData({ city: e?.target?.value })}
            error={errors?.city}
          />
        </div>

        <div className="mt-4">
          <Input
            label="Straat en huisnummer (optioneel)"
            placeholder="Hoofdstraat 123"
            value={formData?.address}
            onChange={(e) => updateFormData({ address: e?.target?.value })}
            description="Wordt alleen gedeeld met geselecteerde providers"
          />
        </div>
      </div>

      {/* Info Box */}
      <div className="bg-info/10 border border-info/20 rounded-lg p-4 flex items-start space-x-3">
        <Icon name="Info" size={20} className="text-info flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm text-foreground font-medium mb-1">Privacy beschermd</p>
          <p className="text-xs text-muted-foreground">
            Uw exacte adres wordt alleen gedeeld met providers die u selecteert. Uw postcode wordt gebruikt voor matching met providers in uw regio.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PropertyInfoStep;